import api from '../api';

export const getPerformanceIndicators = async (companyId: string | number, year?: number) => {
  const params: { company_id: string | number; year?: number } = { company_id: companyId };
  if (year) {
    params.year = year;
  }

  const response = await api.get(`/api/v2/performance-indicators/${companyId}`, { params });
  return response.data;
};
